module.exports = __webpack_public_path__ + "static/img/visual_sub_title_m.428625c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/visual_sub_title_m.png
// module id = 1ung
// module chunks = 0